var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 314,
    height: 68,
    viewBox: "0 0 314 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M303.709 10.4306C274.984 30.9989 227.078 67.6108 163.64 49.1121C103.605 31.6058 83.2144 -20.2618 3.08457 8.5374L5.60376e-05 43.535C73.3486 17.1729 103.252 48.6645 145.86 61.0889C216.96 81.822 283.614 45.2908 313.399 23.9633L303.709 10.4306Z",
    fill: "#726FB3",
    fillOpacity: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWave);
export default __webpack_public_path__ + "static/media/wave.ab788ff47d58f9c0e165ccfe51630137.svg";
export { ForwardRef as ReactComponent };